import { useState } from "react";

import { Sync as SyncIcon } from "@mui/icons-material";
import { ConfirmModal } from "../../../Modals/ConfirmModal";
import { EVENTS_SERVICES } from "../../../../services";
import { ToastManager } from "../../../common/ToastContainer";
import { SESSION_AUTH } from "../../../../helpers/auth";
import { useParams } from "react-router-dom";
import FullPageProgress from "../../../common/FullPageProgress";

const EventOrgazinationNewsTrack = (props) => {
  const [confirm, setOpenConfirm] = useState(false);
  const { accountId } = useParams();
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [loader, setLoader] = useState(false);
  const [syncType, setSyncType] = useState("yahoo");

  const syncLatestNews = () => {
    setOpenConfirm(false);
    setLoader(true);
    EVENTS_SERVICES.syncOrgNews({
      userId: userSession.userId,
      accountId: accountId,
      type: syncType,
    })
      .then((data) => {
        if (data.code === 200) {
          ToastManager.addToast(data?.message);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  return (
    <>
      {loader && <FullPageProgress />}
      <button
        type="button"
        onClick={() => {
          setOpenConfirm(true);
          setSyncType("yahoo");
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary mr-5"
      >
        <SyncIcon className="m-r-5" /> Sync News Yahoo
      </button>
      <button
        type="button"
        onClick={() => {
          setOpenConfirm(true);
          setSyncType("marketscreener");
        }}
        className="managepro6ix-btn managepro6ix-btn-sm managepro6ix-btn-primary mr-5"
      >
        <SyncIcon className="m-r-5" /> Sync News Market Screener
      </button>
      {confirm && (
        <ConfirmModal
          title={`Sync Latest News with (${syncType})`}
          message={`<p>   Are you sure? </p>`}
          request={confirm}
          cancel={() => {
            setOpenConfirm(false);
          }}
          accept={syncLatestNews}
        />
      )}
    </>
  );
};

export default EventOrgazinationNewsTrack;
